import React, { useState, useEffect } from "react";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import { useNavigate, useParams } from "react-router-dom";
import { Row, Col, Table } from "react-bootstrap";
import { Button } from "react-bootstrap";
import HandleHttpErrors from "../HandleHttpErrors";

const baseURL = process.env.REACT_APP_API_JOBS;

const DisplayMoamadiot = () => {
  const { mekhraz_id, member_id } = useParams();
  const [moamadiot, setMoamadiot] = useState(null);
  const [exists, setExists] = useState(false);
  const [bhinaMembers, setBhinaMembers] = useState([]);
  const axiosPrivate = useAxiosPrivate("application/json");
  let history = useNavigate();
  const yesterday = new Date();
  yesterday.setDate(yesterday.getDate() - 1);
  const formattedYesterday = yesterday.toISOString().split("T")[0];

  useEffect(() => {
    let isMounted = true;
    const controller = new AbortController();

    const getData = async () => {
      try {
        const response = await axiosPrivate.get(
          baseURL + "moamad?mekhraz_id=" + mekhraz_id,
          {
            signal: controller.signal,
          },
        );
        isMounted &&
          setMoamadiot(response.data.filter((item) => item.saf === true));
      } catch (err) {
        if (err.response) {
          alert(HandleHttpErrors(err.response.status));
        } else if (err.request) {
          alert(
            " The client never received a response, and the request was never left",
          );
          console.log(err.request);
        } else {
          alert(" Anything else");
        }
      }
    };
    getData();
    return () => {
      isMounted = false;
      isMounted && controller.abort();
    };
  }, []);
  useEffect(() => {
    let isMounted = true;
    const controller = new AbortController();
    const getData = async () => {
      try {
        const response = await axiosPrivate.get(
          baseURL + "bhinamember?mekhraz_id=" + mekhraz_id,
          {
            signal: controller.signal,
          },
        );
        if (isMounted) {
          setBhinaMembers(response.data);
          const foundMember = response.data.find(
            (item) => String(item.memberlist) === String(member_id),
          );
          if (foundMember) {
            setExists(true);
          } else {
            setExists(false);
          }
        }
      } catch (err) {
        if (err.response) {
          alert(HandleHttpErrors(err.response.status));
        } else if (err.request) {
          alert(
            " The client never received a response, and the request was never left",
          );
          console.log(err.request);
        } else {
          alert(" Anything else");
        }
      }
    };

    getData();
  }, []);
  if (!exists)
    return (
      <article
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          height: "100vh",
        }}
      >
        <h4>מצטערים, ההרשאה לצפות בהצעות היא רק לחברי וועדת הבחינה.</h4>
      </article>
    );
  else
    return (
      <>
        <div className="mx-auto">
          <Row>
            <Col sm="10" md={{ size: 3, offset: 1 }}>
              <form>
                <Table hover>
                  <thead>
                    <tr>
                      <th>מספר המועמדות</th>
                      <th>שם </th>
                      <th>פעולה</th>
                    </tr>
                  </thead>
                  <tbody>
                    {moamadiot?.map((moamadoot) => (
                      <tr key={moamadoot.id}>
                        <td>{moamadoot.id}</td>
                        <td>
                          {moamadoot.f_name}
                          {moamadoot.father_name
                            ? " " + moamadoot.father_name + " "
                            : " "}
                          {moamadoot.l_name}
                        </td>
                        <td>
                          {" "}
                          <Button
                            variant="danger"
                            value={moamadoot.id}
                            onClick={() =>
                              history(
                                "/moamadoot/" +
                                  moamadoot.id +
                                  "/" +
                                  "ABC" +
                                  "/" +
                                  formattedYesterday,
                              )
                            }
                          >
                            צפייה בהצעה
                          </Button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </form>
            </Col>
          </Row>
        </div>
      </>
    );
};
export default DisplayMoamadiot;
